import store from '@/store'

export default [
  {
    path: '/class-operations',
    name: 'class-operation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-operation/index.vue')
  },
  {
    path: '/class-operations/create',
    name: 'class-operation-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-operation/create.vue')
  },
  {
    path: '/class-operations/:id',
    name: 'class-operation-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-operation/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('classOperation/find', to.params.id)
      next()
    }
  },
  {
    path: '/class-operations/copy-class/:id',
    name: 'class-operation-copy-class',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-operation/copy-class.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('classOperation/find', to.params.id)
      next()
    }
  }
]
